<template>
    <div class="show_more__container">
        <div :class="{expanded: isExpanded}">{{ text }}</div>
        <a class="anchor" @click.prevent="onToggle">{{ getLinkTitle }}</a>
    </div>
</template>

<script>
export default {
    name: "ShowMore",
    data() {
        return {
            isExpanded: false,
        };
    },
    props: {
        text: {
            type: String,
            required: true
        },
        countStrings: {
            type: Number,
            required: true,
        }
    },
    computed: {
        getLinkTitle() {
            return this.isExpanded ? this.$t("lang.main.btn.hide") : this.$t("lang.main.btn.more");
        },
    },
    methods: {
        onToggle() {
            this.isExpanded = !this.isExpanded;
        }
    }
}
</script>

<style scoped>
:deep(.dashboard) .show_more__container {
    margin: 20px auto 0;
}
.show_more__container {
    text-align: left;
    font-size: 14px;
    line-height: 22px;
    margin: 0 auto;
    padding: 0;
    width: auto;
}
.show_more__container div {
    white-space: pre-line;
    display: -webkit-box;
    -webkit-line-clamp: v-bind(countStrings);
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.show_more__container .expanded {
    -webkit-line-clamp: unset;
}
.show_more__container .anchor {
    display: block;
    padding: 8px 0;
    color: #fff;
    text-decoration: underline;
    text-align: left;
    cursor: pointer;
}
</style>
